import React, { useState } from 'react';
import './LeadManagementPage.css';
import LeadList from '../../components/admin/lead/LeadList';
import { Alert } from '../../components/common';

function LeadManagementPage() {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  return (
    <div className="lead-management">
      <div className="lead-management__header">
        <div className="lead-management__header-left">
          <h1 className="lead-management__title">Lead Management</h1>
          <p className="lead-management__subtitle">
            View and manage leads from your lead magnets
          </p>
        </div>
      </div>

      {/* Alerts */}
      {error && (
        <Alert
          variant="error"
          onClose={() => setError(null)}
          className="lead-management__alert"
        >
          {error}
        </Alert>
      )}
      {success && (
        <Alert
          variant="success"
          onClose={() => setSuccess(null)}
          className="lead-management__alert"
        >
          {success}
        </Alert>
      )}

      {/* Lead List */}
      <LeadList
        onError={setError}
        onSuccess={setSuccess}
      />
    </div>
  );
}

export default LeadManagementPage;











